import { useEffect, useRef, useState } from 'react';

import { motion, AnimatePresence, delay, transform } from 'framer-motion';

import './Promo100Pc.css';
import { IMG_PLACEHOLDER_PROMO, MAIN_URL } from '../../../../../assets/utils/constants';
import useWindowSize from '../../../../../assets/hooks/useWindowSize';
import { AudemarsPiguetIcon, BvlgariIcon, HermesIcon, PatekPhilippeIcon, RichardMileIcon, RolexIcon, SliderArrowIcon } from '../../../../../assets/icons/promo100';
import { Link, useNavigate } from 'react-router-dom';

const cinematicEase = [0.7, 0, 0.3, 1];

const getResponsiveImage = (slide, width) => {
    if (width >= 1024 && slide.image?.urls?.orig) {
        return slide.image.urls.orig;
    } else if (width >= 768 && width < 1024 && slide.image_tablet?.urls?.orig) {
        return slide.image_tablet.urls.orig;
    } else if (width < 768 && slide.image_mobile?.urls?.orig) {
        return slide.image_mobile.urls.orig;
    } else {
        // Возвращаем заглушку, если нет изображения для текущего размера экрана
        return slide.image?.urls?.orig || IMG_PLACEHOLDER_PROMO;
    }
};

function Bullets({ items, additionalClass, goToSlide, currentIndex }) {
    return (
        <div className={`promo100-pc__content-main-center-bullets ${additionalClass ? additionalClass : ''}`}>
            {items.map((bullet, i) => (
                <button className={`promo100-pc__content-main-center-bullet ${i === currentIndex ? 'promo100-pc__content-main-center-bullet_active' : ''}`} onClick={() => {
                    goToSlide(i)
                }}>
                    <div className={`promo100-pc__content-main-center-bullet-inner`} />
                </button>
            ))}
        </div>
    )
}
/**
 * Варианты анимации для всего контейнера
 * (движение вверх/вниз + прозрачность)
 */
const textContainerVariants = {
    enter: {
        opacity: 0,
        y: -150,
        transition: { duration: 0.6, ease: cinematicEase, },
    },
    center: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            // Порядок: сначала сам «контейнер» (класс promo100-pc__content-main-texts-box),
            // затем начинаем анимировать детей по очереди:
            // when: "beforeChildren",
            staggerChildren: 0.2, // интервал между появлением каждого child
            delay: 1,
            ease: cinematicEase,
        },
    },
    exit: {
        opacity: 0,
        y: 150,
        transition: { duration: 0.6, ease: cinematicEase },
    },
};

/**
 * Варианты анимации для каждого дочернего элемента (заголовок, саб, описание)
 * (просто прозрачность + небольшое движение, для наглядности)
 */
const textContainerChildVariants = {
    enter: {
        opacity: 0,
    },
    center: {
        opacity: 1,
        transition: {
            duration: 0.2,
            ease: cinematicEase,
        },
    },
    exit: {
        opacity: 0,

    },
};

const watchImageVariants = {
    enter: {
        opacity: 0,
        x: 300,       // или y, scale — на ваш вкус
        transition: { duration: 1, ease: cinematicEase, },
    },
    center: {
        opacity: 1,
        x: 0,
        transition: { duration: 1, ease: cinematicEase, },
    },
    exit: {
        opacity: 0,
        x: -300,
        transition: { duration: 1, ease: cinematicEase, },
    },
};

const promotionContainerVariants = {
    enter: {
        opacity: 0,
        scale: 0,
    },
    center: {
        opacity: 1,
        scale: 1,
        transition: {
            duration: 0.6,
            // Animate children *after* parent finishes its enter animation
            // when: "beforeChildren",
            // The delay between each child’s animation start
            staggerChildren: 0.15,
            ease: cinematicEase,
        },
    },
    exit: {
        opacity: 0,
        scale: 0,
        transition: {
            duration: 0.6,
            ease: cinematicEase,
        },
    },
};

const promotionContainerVariants2 = {
    enter: {
        opacity: 0,
        scale: 0,
    },
    center: {
        opacity: 1,
        scale: 1,
        transition: {
            duration: 0.4,
            // Animate children *after* parent finishes its enter animation
            // when: "beforeChildren",
            // The delay between each child’s animation start
            staggerChildren: 0.15,
            ease: cinematicEase,
        },
    },
    exit: {
        opacity: 0,
        scale: 0,
        transition: {
            duration: 0.4,
            ease: cinematicEase,
        },
    },
};

const promotionItemVariants = {
    enter: {
        opacity: 0,
        // y: 50,
    },
    center: {
        opacity: 1,
        // y: 0,
        transition: {
            duration: 0.3,
            ease: cinematicEase,
        },
    },
    exit: {
        opacity: 0,
        // y: -50,
        transition: {
            duration: 0.3,
            ease: cinematicEase,
        },
    },
};



function Promo100Pc({
    item,
    blackBannerRef,
}) {
    const navigate = useNavigate()
    const { width } = useWindowSize()
    const mainContent = useRef(null)
    const mainImg = useRef(null)

    const [currentIndex, setCurrentIndex] = useState(0); // Track the current slide index
    const [contentWidth, setContentWidth] = useState(0);

    const [fixedWindowHeight, setFixedWindowHeight] = useState(0);
    useEffect(() => {
        setFixedWindowHeight(window.innerHeight)
        // Set the width once the component has been mounted
        if (mainContent.current) {
            setContentWidth(mainContent.current.clientWidth);
        } else {
            setContentWidth(0);
        }
    }, [mainContent]); // This runs when the ref changes


    // const [my_swiper, set_my_swiper] = useState({});
    console.log({ item })
    console.log({
        data: {
            ...item.data[0],
            ...JSON.parse(item.data[0].title),

        }
    })
    const [resetTimer, setResetTimer] = useState(0);
    useEffect(() => {
        // Set interval for automatic slide change
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % item.data.length);
        }, 6000); // Change slide every 3 seconds

        return () => clearInterval(interval); // Clean up on component unmount
    }, [item.data.length, resetTimer]);

    const CURRENT_SLIDE = {
        ...item.data[currentIndex],
        ...JSON.parse(item.data[currentIndex].title),
    }

    // Функция для смены слайда
    const goToSlide = (newIndex) => {
        // Здесь можете проверять границы, например,
        // если newIndex выходит за пределы, вернуться в 0 или в последний
        setCurrentIndex(newIndex);
        setResetTimer((prev) => prev + 1);
    };

    const [imgCenterX, setImgCenterX] = useState(0);

    useEffect(() => {
        if (mainImg.current) {
            const rect = mainImg.current.getBoundingClientRect();
            // например, вычисляем «центр» картинки по оси X
            setImgCenterX(rect.left + rect.width / 2);
        }
    }, [mainImg]);

    const circleRightVariants = {
        enter: {
            // opacity: 0,
            scale: 0.0,
            x: 100,       // или y, scale — на ваш вкус
            transition: { duration: 0.5, ease: cinematicEase, },
        },
        center: {
            opacity: 1,
            x: 0,
            scale: 1,
            width: `${mainImg?.current?.clientWidth ? mainImg.current.clientWidth * 0.5 : 0}px`,
            height: `${mainImg?.current?.clientWidth ? mainImg.current.clientWidth * 0.5 : 0}px`,
            transition: { duration: 1, ease: cinematicEase, },
        },
        exit: (custom) => ({
            opacity: 0,
            x: -custom?.targetX - (mainImg?.current?.clientWidth / 2 ?? 0) + 100 ?? 0,
            width: `${mainImg?.current?.clientWidth ? mainImg.current.clientWidth * 0.9 : 0}px`,
            height: `${mainImg?.current?.clientWidth ? mainImg.current.clientWidth * 0.9 : 0}px`,
            transition: { duration: 1.8, delay: 0.5, ease: cinematicEase, },
        }),
    };


    return (
        <div className='promo100-pc' ref={blackBannerRef} style={{
            minHeight: fixedWindowHeight ? `${fixedWindowHeight * 0.9}px` : 'auto'
        }}>
            <div className='promo100-pc__content-number-box'
                style={{
                    width: contentWidth ? width <= 1100 ? "22px" : `calc(${width - contentWidth}px / 2 - ${width <= 1435 ? width <= 1100 ? '10px' : '20px' : '40px'} + ${width <= 1435 ? width <= 1100 ? '32px' : '64px' : '120px'})` : 'unset',
                }}
            >
                <p className='promo100-pc__content-number-box-text'>
                    0{currentIndex + 1}
                </p>
            </div>
            <div className='promo100-pc__content'>

                {item.data.length > 0 ?
                    <Bullets
                        additionalClass={'promo100-pc__content-main-center-bullets_1250'}
                        items={item.data}
                        currentIndex={currentIndex}
                        goToSlide={goToSlide}
                    />
                    : null}
                {console.log({ contentWidth: contentWidth, cur: mainContent?.current })}
                <div className='promo100-pc__content-main' >
                    <div className='promo100-pc__content-main-box' ref={mainContent} style={{
                        left: contentWidth ? `calc(${width - contentWidth}px / 2)` : 'unset',
                    }}>

                        {/* Анимируем сам блок с текстами через AnimatePresence + motion.div */}
                        <AnimatePresence mode="popLayout">
                            <motion.div
                                key={currentIndex}
                                variants={textContainerVariants}
                                initial="enter"
                                animate="center"
                                exit="exit"
                                className='promo100-pc__content-main-texts-box'
                            >
                                <div className='promo100-pc__content-main-titles'>
                                    {CURRENT_SLIDE.title?.main && (
                                        <motion.p
                                            variants={textContainerChildVariants}
                                            className='promo100-pc__content-main-title'
                                        >
                                            {CURRENT_SLIDE.title.main}
                                        </motion.p>
                                    )}
                                    {CURRENT_SLIDE.title?.sub && (
                                        <motion.p
                                            variants={textContainerChildVariants}
                                            className='promo100-pc__content-main-subtitle'
                                        >
                                            {CURRENT_SLIDE.title.sub}
                                        </motion.p>
                                    )}
                                </div>

                                {CURRENT_SLIDE.description && (
                                    <motion.p
                                        variants={textContainerChildVariants}
                                        className='promo100-pc__content-main-description'
                                    >
                                        {CURRENT_SLIDE.description}
                                    </motion.p>
                                )}


                            </motion.div>
                        </AnimatePresence>

                        <div className='promo100-pc__content-main-center'>
                            <AnimatePresence mode="wait">
                                <motion.div
                                    key={CURRENT_SLIDE.promo_product.icon}
                                    variants={promotionContainerVariants}
                                    initial="enter"
                                    animate="center"
                                    exit="exit"
                                    className='promo100-pc__content-main-center-logo-box'
                                >
                                    {CURRENT_SLIDE.promo_product.icon === 'ROLEX' ?
                                        <RolexIcon mainClassName={'promo100-pc__content-main-center-logo promo100-pc__content-main-center-logo_rolex'} fillClassName={'promo100-pc__content-main-center-logo-fill'} />
                                        :
                                        null}
                                    {CURRENT_SLIDE.promo_product.icon === 'PATEK_PHILIPPE' ?
                                        <PatekPhilippeIcon mainClassName={'promo100-pc__content-main-center-logo promo100-pc__content-main-center-logo_patek-philippe'} fillClassName={'promo100-pc__content-main-center-logo-fill'} />
                                        : null}
                                    {CURRENT_SLIDE.promo_product.icon === 'RICHARD_MILE' ?
                                        <RichardMileIcon mainClassName={'promo100-pc__content-main-center-logo promo100-pc__content-main-center-logo_richard-mile'} fillClassName={'promo100-pc__content-main-center-logo-fill'} />
                                        : null}
                                    {CURRENT_SLIDE.promo_product.icon === 'AUDEMARS_PIGUET' ?
                                        <AudemarsPiguetIcon mainClassName={'promo100-pc__content-main-center-logo promo100-pc__content-main-center-logo_audemars-piguet'} fillClassName={'promo100-pc__content-main-center-logo-fill'} />
                                        : null}
                                    {CURRENT_SLIDE.promo_product.icon === 'BVLGARI' ?
                                        <BvlgariIcon mainClassName={'promo100-pc__content-main-center-logo promo100-pc__content-main-center-logo_bvlgari'} fillClassName={'promo100-pc__content-main-center-logo-fill'} />
                                        : null}
                                    {CURRENT_SLIDE.promo_product.icon === 'HERMES' ?
                                        <HermesIcon mainClassName={'promo100-pc__content-main-center-logo promo100-pc__content-main-center-logo_hermes'} fillClassName={'promo100-pc__content-main-center-logo-fill'} />
                                        : null}
                                </motion.div>
                            </AnimatePresence>
                            <div className='promo100-pc__content-main-center-img-box'>
                                <div className="promo100-pc__content-main-center-img-container" ref={mainImg} onClick={() => {
                                    navigate(CURRENT_SLIDE.link)
                                }}>
                                    <AnimatePresence mode="wait">
                                        {CURRENT_SLIDE?.image?.urls?.orig && (
                                            <motion.img
                                                key={CURRENT_SLIDE.image.urls.orig}  // ВАЖНО: уникальный ключ
                                                src={CURRENT_SLIDE.image.urls.orig}
                                                alt=""
                                                className="promo100-pc__content-main-center-img"
                                                variants={watchImageVariants}
                                                initial="enter"
                                                animate="center"
                                                exit="exit"
                                            />
                                        )}
                                    </AnimatePresence>
                                </div>


                                <div className='promo100-pc__content-main-center-img-shape promo100-pc__content-main-center-img-shape_1'></div>
                                <div className='promo100-pc__content-main-center-img-shape promo100-pc__content-main-center-img-shape_2'></div>

                                <div className="promo100-pc__content-main-center-img-promotion">
                                    <AnimatePresence mode="wait">
                                        {CURRENT_SLIDE.products_count && Number(CURRENT_SLIDE.products_count) > 0 ?
                                            <motion.button
                                                key={currentIndex + "_promotionContainer"}
                                                variants={promotionContainerVariants}
                                                initial="enter"
                                                animate="center"
                                                exit="exit"
                                                onClick={() => {
                                                    navigate(CURRENT_SLIDE.catalog_link)
                                                }}
                                                className="promo100-pc__content-main-center-img-promotion-products"
                                            >
                                                <motion.p variants={promotionItemVariants} className="promo100-pc__content-main-center-img-promotion-products-count">
                                                    {CURRENT_SLIDE.products_count}
                                                </motion.p>
                                                <motion.p className="promo100-pc__content-main-center-img-promotion-products-title">
                                                    {CURRENT_SLIDE.products_title ? CURRENT_SLIDE.products_title : 'PRODUCTS'}
                                                </motion.p>
                                            </motion.button>
                                            : null}
                                        {CURRENT_SLIDE.brands_count && Number(CURRENT_SLIDE.brands_count) > 0 ?
                                            <motion.button
                                                key={currentIndex + "_promotionContainer_brands"}
                                                variants={promotionContainerVariants}
                                                initial="enter"
                                                animate="center"
                                                exit="exit"
                                                type='button'
                                                onClick={() => {
                                                    navigate(CURRENT_SLIDE.catalog_link)
                                                }}
                                                className="promo100-pc__content-main-center-img-promotion-brands"
                                            >
                                                <motion.p variants={promotionItemVariants} className="promo100-pc__content-main-center-img-promotion-brands-count">
                                                    {CURRENT_SLIDE.brands_count}
                                                </motion.p>
                                                <motion.p variants={promotionItemVariants} className="promo100-pc__content-main-center-img-promotion-brands-title">
                                                    {CURRENT_SLIDE.brands_title ? CURRENT_SLIDE.brands_title : 'BRANDS'}
                                                </motion.p>
                                            </motion.button>
                                            : null}
                                    </AnimatePresence>

                                </div>
                            </div>
                            <AnimatePresence mode="wait">
                                <motion.div
                                    key={currentIndex + "_promo100-pc__content-main-center-product"}
                                    variants={promotionContainerVariants}
                                    initial="enter"
                                    animate="center"
                                    exit="exit"
                                    className='promo100-pc__content-main-center-product'
                                >
                                    <p className='promo100-pc__content-main-center-product-name'>{CURRENT_SLIDE.promo_product.name}</p>
                                    <Link to={CURRENT_SLIDE.link} className='promo100-pc__content-main-center-product-price'>
                                        {CURRENT_SLIDE.promo_product.price}
                                    </Link>
                                </motion.div>
                            </AnimatePresence>

                            {item.data.length > 0 ?
                                <Bullets
                                    additionalClass={'promo100-pc__content-main-center-bullets_1400'}
                                    items={item.data}
                                    currentIndex={currentIndex}
                                    goToSlide={goToSlide}
                                />
                                : null}

                        </div>
                        <div className='promo100-pc__content-right'>
                            <div className='promo100-pc__content-right-line'>
                                <svg className='promo100-pc__content-right-line-blob' width="68" height="8" viewBox="0 0 68 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path className='promo100-pc__content-right-line-blob-fill' d="M68 4C68 4 52.7777 8 34 8C15.2223 8 0 4 0 4C0 4 15.2223 0 34 0C52.7777 0 68 4 68 4Z" fill="white" />
                                </svg>
                            </div>
                            <AnimatePresence mode="wait">
                                <motion.button
                                    key={currentIndex + 'promo100-pc__content-right-next'}
                                    className='promo100-pc__content-right-next'
                                    variants={circleRightVariants}
                                    initial="enter"
                                    animate="center"
                                    exit="exit"
                                    custom={{ targetX: imgCenterX }}
                                    onClick={() => {
                                        goToSlide((currentIndex + 1) % item.data.length)
                                    }}
                                    type='button'
                                />
                            </AnimatePresence>

                        </div>
                    </div>
                    <button className='promo100-pc__main-arrow-btn promo100-pc__main-arrow-btn_left' type='button' onClick={() => {
                        goToSlide((currentIndex - 1) >= 0 ? (currentIndex - 1) : item.data.length - 1)
                    }}>
                        <SliderArrowIcon
                            mainClassName={'promo100-pc__main-arrow'}
                            fillClassName={'promo100-pc__main-arrow-fill'}
                        />
                    </button>
                    <button className='promo100-pc__main-arrow-btn promo100-pc__main-arrow-btn_right' type='button' onClick={() => {
                        goToSlide((currentIndex + 1) % item.data.length)
                    }}>
                        <SliderArrowIcon
                            mainClassName={'promo100-pc__main-arrow promo100-pc__main-arrow_rotated'}
                            fillClassName={'promo100-pc__main-arrow-fill'}
                        />
                    </button>
                </div>

            </div>
        </div >
    );
}

export default Promo100Pc